module.exports = __webpack_public_path__ + "static/introduction_img1@2x-b2e12fbd8695ba439cba44086069c835.jpg";